import http from './http'
import Resource from './resource'

const path = 'admin/categories'

class Categories extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const CategoriesRequest = new Categories(http)

export default CategoriesRequest
